/**
 * Langue de la page transmise à l'API, côté NAVIGATEUR — pendant de
 * server/plugins/langue-api.ts : les textes écrits par les associations
 * (cagnottes, adhésions, événements, boutiques…) arrivent traduits dans la
 * langue de la page, y compris quand une page se recharge ou qu'on navigue.
 *
 *  - appels à l'API Donoor : `Accept-Language: <langue>` (forme exacte, la
 *    seule que l'API traduit ; « sûre » pour le navigateur, pas de requête
 *    CORS préalable) ;
 *  - appels aux routes /api du site : `?langue=<langue>` (le serveur du site
 *    la transmet à l'API ; dans l'adresse, le cache du CDN ne mélange pas
 *    les langues).
 *
 * Changement de langue (sélecteur) : les données déjà chargées l'ont été
 * dans l'ancienne langue → on les recharge.
 */
import { useQueryClient } from "@tanstack/vue-query";

export default defineNuxtPlugin({
  name: "donoor-langue-api",
  dependsOn: ["donoor-data-layer"],
  setup(nuxtApp) {
    const apiUrl = String(useRuntimeConfig().public.apiUrl || "").replace(/\/$/, "");
    const langue = () => String(nuxtApp.$i18n.locale.value || "fr");

    const avant = globalThis.$fetch;
    globalThis.$fetch = avant.create({
      onRequest({ request, options }) {
        const url = typeof request === "string" ? request : request.url;
        // « fr » compris (14/10/2026) : les textes écrits dans une autre
        // langue par une association sont traduits en français.
        const l = langue();
        if (apiUrl && url.startsWith(apiUrl)) {
          const entetes = new Headers(options.headers as HeadersInit | undefined);
          entetes.set("Accept-Language", l);
          options.headers = entetes;
        } else if (url.startsWith("/api/")) {
          options.query = { ...(options.query ?? {}), langue: l };
        }
      },
    }) as typeof globalThis.$fetch;

    nuxtApp.hook("i18n:localeSwitched", () => {
      void refreshNuxtData();
      try {
        void nuxtApp.vueApp.runWithContext(() => useQueryClient()).invalidateQueries();
      } catch {
        // pas de vue-query sur cette page
      }
    });
  },
});
